import { reportMember } from '@wix/ambassador-members-v1-member-report/http';
import { Reason } from '@wix/ambassador-members-v1-member-report/types';
import { HttpClient } from '@wix/http-client';

class ReportMemberService {
  constructor(private readonly getAppToken: () => string) {}

  async reportMember(reportedMemberId: string, reportingMemberId: string, reason: Reason) {
    const httpClient = new HttpClient({ getAppToken: this.getAppToken });

    await httpClient.request(reportMember({ memberReport: { reportedMemberId, reportingMemberId, reason } }));
  }
}

export default ReportMemberService;
